import { render, staticRenderFns } from "./ConsultarUnimed.vue?vue&type=template&id=2114722d"
import script from "./ConsultarUnimed.vue?vue&type=script&lang=js"
export * from "./ConsultarUnimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports